import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-airdisk-fleet-safety',
  templateUrl: './airdisk-fleet-safety.component.html',
  styleUrls: ['./airdisk-fleet-safety.component.scss'],
  standalone: false
})
export class AirdiskFleetSafetyComponent {
  private readonly destroy$ = new Subject<void>();
  fleetInfoData: any;
  subscription = new Subscription();
  isTractor: boolean = false;
  constructor(public airdiskService: AirdiskbrakeService, private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.subscription = this.airdiskService.selectedOption$.subscribe(option => {
      if (option) {
        this.isTractor = option === 'Tractor';
      } else {
        this.isTractor = true;
      }
    });

    this.airdiskService.fleetInfoData$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.fleetInfoData = x;
    });

    this.airdiskService.fleetSafetyData$.pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data != null) {
          this.fleetSafetyForm.patchValue({
            annualFleetAccidentRate: data.annualFleetAccidentRate || 10,
            noOfRearEndCollisionsDuringLifecycle: data.noOfRearEndCollisionsDuringLifecycle || 114,
            rearEndCollisionUnitCost: data.rearEndCollisionUnitCost || 8584.31,
            lifecycleRearEndCollisionsFleetCost: data.lifecycleRearEndCollisionsFleetCost || 8584314,
          });
        }

      });
    this.calculateAndSetSum();
  }

  fleetSafetyForm = new FormGroup({
    annualFleetAccidentRate: new FormControl(10, { validators: Validators.required }),
    noOfRearEndCollisionsDuringLifecycle: new FormControl(114, { validators: Validators.required }),
    rearEndCollisionUnitCost: new FormControl(8584.31, { validators: Validators.required }),
    lifecycleRearEndCollisionsFleetCost: new FormControl(8584314, { validators: Validators.required }),
  });
  get form() {
    return this.fleetSafetyForm.controls;
  }

  onFormChanges(): void {
    this.fleetSafetyForm.get('annualFleetAccidentRate')?.valueChanges.subscribe(() => {
      this.calculateAndSetSum();
    });

    this.storeDataOnChange();
  }


  calculateAndSetSum(): void {
    const E13 = this.fleetInfoData?.fleetSize;

    const E15 = this.isTractor ? this.fleetInfoData?.tractorTradeInCycle : this.fleetInfoData?.trailerTradeInCycle;

    const E24 = +this.fleetSafetyForm.get('annualFleetAccidentRate')?.value || 0;

    const E25 = Math.round(E13 * (E24 / 100) * 0.228 * E15);

    const E27 = E25 * 75301;
    const E26 = E27 / E13;

    this.fleetSafetyForm.patchValue({
      noOfRearEndCollisionsDuringLifecycle: E25,
      rearEndCollisionUnitCost: Number(E26.toFixed(2)),
      lifecycleRearEndCollisionsFleetCost: Math.round(E27),
    });

  }

  storeDataOnChange() {

    if (this.fleetSafetyForm.valid) {
      this.airdiskService.fleetSafetyData$.next(this.fleetSafetyForm.value);
    }
    else {
      this.fleetSafetyForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }

  endaSureNxt() {
    this.storeDataOnChange();
    this.airdiskService.currentComponent$.next('frictionMaintainance');
  }

  endaSureBack() {
    this.airdiskService.currentComponent$.next('fleetInfo');
    this.storeDataOnChange();
  }

  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
  }
}
